// @ts-nocheck
import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

export const EarningsCard = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.medium,
    padding: `${theme.spacing.medium} ${theme.spacing.large}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
}));

export const EarningsSection = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    flex: 1,
    position: "relative" as const,
}));

export const EarningsDivider = styled.div(({ theme }) => ({
    width: 1,
    height: 48,
    backgroundColor: theme.colors[theme.colorMode].border_Tertiary,
}));

export const EarningsValue = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
    marginBottom: 2,
}));

export const EarningsAmount = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].positive,
    marginBottom: 2,
}));

export const EarningsLabel = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.xxSmall,
}));

export const EarningsIcon = styled(Image)(({ theme }) => ({
    width: theme.spacing.small,
    height: theme.spacing.small,
}));
